export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/repair/query`,
          data
        });
      },
      list(data) {
          return http.json({
              url: `/repair/list`,
              data
          })
      },
      /**
       * 获取报修详情
       * @param data
       * @return {*}
       */
      getRepairInfo(data) {
          return http.json({
              url: `/repair/get?id=${data.id}`
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/repair.js